import columns from '../../../react-table/helpers/columns';

export default (data, assetType) => {
  const {
    TextColumn, DateColumn, NumberColumn, RadioButtonColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Location', 'operatorCode'),
        new DateColumn('Date', 'date'),
      ],
    },
    {
      Header: 'Select a location for',
      columns: [
        new RadioButtonColumn('Repat from', 'operatorCode', false, 'repatFrom'),
        new RadioButtonColumn('Repat to', 'operatorCode', false, 'repatTo'),
      ],
    },
    {
      Header: 'Generated from PREDES',
      columns: [
        new NumberColumn('In', 'generatedFromPredes.in'),
        new NumberColumn('Out', 'generatedFromPredes.out'),
        new NumberColumn('Total', 'generatedFromPredes.total'),
      ],
    },
    {
      Header: 'Manual Pre-Advise',
      columns: [
        new NumberColumn('In', 'manualPreadvice.in'),
        new NumberColumn('Out', 'manualPreadvice.out'),
        new NumberColumn('Total', 'manualPreadvice.total'),
      ],
    },
    {
      Header: 'Center Initiated Repat',
      columns: [
        new NumberColumn('In', 'centralRepatriation.in'),
        new NumberColumn('Out', 'centralRepatriation.out'),
        new NumberColumn('Total', 'centralRepatriation.total'),
      ],
    },
    {
      Header: 'Internal Repat',
      columns: [
        new NumberColumn('In', 'internalRepatriation.in'),
        new NumberColumn('Out', 'internalRepatriation.out'),
        new NumberColumn('Total', 'internalRepatriation.total'),
      ],
    },
    {
      Header: 'Total',
      columns: [
        new NumberColumn('In', 'total.in'),
        new NumberColumn('Out', 'total.out'),
        new NumberColumn('Flux', 'total.flux'),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Balance Modification', 'balanceModificationCount'),
        new NumberColumn('Balance on Hand', 'balanceOnHand'),
        new NumberColumn('Member Pool Storage', 'trayStorageCount').withShow(assetType === 'tray'),
      ],
    },
  ];
};
